import React from 'react';
import { formatDate, formatIndianCurrency, getLoanDisbursementDetails } from '../../utils/Utils';

const Transactions = ({ data, labels }) => {
    const { Summary, Transactions } = data;
    const loanDisbursedRow = getLoanDisbursementDetails(data);

    return (
        <div className="bg-gray-100  mx-auto h-full flex flex-col">
            {/* Transactions Header */}
            <div className="bg-yellow-500 text-center py-2 font-semibold fs-32w mt-4">
                {labels.transactionsHeader}
            </div>
            <div className="grid grid-cols-3 text-center bg-red-200 mt-1 py-2">
                <span>{loanDisbursedRow.Date}</span>
                <span>{loanDisbursedRow.Description}</span>
                <span>{formatIndianCurrency(loanDisbursedRow.Amount)}</span>

            </div>
            {/* Scrollable Transactions Section */}
            <div className="flex-grow overflow-y-auto fs-30w">
                {Transactions?.sort((a, b) => new Date(b.TransactionDate) - new Date(a.TransactionDate)).map((transaction, index) => (
                    <div
                        key={index}
                        className={`${transaction.Description === 'Collection Default' ? 'bg-red-400' : 'bg-green-200'} mb-2 pb-2`}
                    >
                        <div className="font-poppinsSemibold text-center bg-gray-300 py-2">
                            {formatDate(transaction.TransactionDate)} : {transaction.Description}
                        </div>
                        {/* Four Column Layout */}
                        <div className="grid grid-cols-4 text-center font-semibold pt-2">
                            <span>{labels.principal}</span>
                            <span>{labels.interest}</span>
                            <span>{labels.total}</span>
                            <span>{labels.pos}</span>
                        </div>
                        <div className="grid grid-cols-4 text-center mt-1">
                            <span>{transaction.Principal}</span>
                            <span>{transaction.Interest}</span>
                            <span>{formatIndianCurrency(transaction.Amount)}</span>
                            <span>{formatIndianCurrency(transaction.POS)}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Transactions;
